<template>
  <div v-if="isCardView" class="card-view-container">
    <template v-if="showFilters && !isLoading">
      <search-control-container/>
    </template>
    <div
      v-if="!listData.length && !fetchingListData"
      class="alert alert-warning alert-dismissable mb-3 mt-3 text-center"
    >
      {{ $i18n.t(getListInfo) }}!
    </div>
    <div v-else class="d-flex flex-wrap mt-3">
      <div
        v-for="(row, index) in listData"
        class="card-container col-sm-12"
        :class="{ 'col-md-6': listData.length > 1 }"
        :key="index"
      >
        <card-view :row-id="row['ROW_KEY']" :row-index="index" :record-lock="row['RECORD_LOCK']" />
      </div>
    </div>
    <div v-if="infiniteScroll" ref="infinite">
      <loader v-if="fetchingListData" :is-in-line="true"></loader>
    </div>
  </div>
</template>

<script>
import CardView from './CardView'
import Loader from '../../../Loader'
import SearchButton from '../../search/SearchButton'
import SearchControlContainer from '../../search/SearchControlContainer'
import EventBus from '../../../../utils/event-bus'
import { cloneDeep, get, isEmpty } from 'lodash'
import localStore from '../../../../utils/mixin-local-store'
import pagination from '../../../../utils/mixin-pagination'

export default {
  name: 'CardViewContainer',
  mixins: [localStore, pagination],
  components: {
    CardView,
    Loader,
    SearchButton,
    SearchControlContainer,
  },
  data() {
    return {
      isLoading: true,
      isSearchBarCollapsed: false
    }
  },
  computed: {
    defaultEmpty() {
      return this.$get('defaultEmpty')
    },
    fetchingListData() {
      return this.$get('fetchingListData')
    },
    getListInfo() {
      if (!this.listData.length && this.isSearchBarActive) return 'list_search_empty'
      if (!this.listData.length && this.isDefaultEmpty) return 'please_search'
      return 'list_empty'
    },
    id() {
      return this.$get('id')
    },
    infiniteScroll() {
      return this.$get('infiniteScroll')
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    isDefaultEmpty() {
      return this.defaultEmpty && !this.selectedRow
    },
    isSearchBarActive() {
      const searchParams = cloneDeep(this.searchParams)
      delete searchParams.start
      return (
        isEmpty(searchParams) && this.selectedRowsFilter === 'normal' && isEmpty(get(this.universalFilter, 'value', ''))
      )
    },
    listData() {
      return this.$get('listData')
    },
    panelId() {
      return this.$get('panelId')
    },
    searchParams() {
      return this.$get('searchParams')
    },
    selectedRow() {
      return this.$get('selectedRow')
    },
    selectedRowsFilter() {
      return this.$get('selectedRowsFilter')
    },
    showFilters() {
      return this.visibilityState({ key: 'showFilters' })
    },
    universalFilter() {
      return this.$get('universalFilter')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
  methods: {
    checkVisible() {
      const loaderRect = this.$refs['infinite']?.getBoundingClientRect()
      const windowHeight = window.innerHeight
      if (loaderRect.top < windowHeight) {
        if (this.fetchingListData) return
        this.loadNextPage()
      }
    },
    loadNextPage() {
      const newOffset = this.offset + this.limit
      if (newOffset > this.total) {
        return
      } else {
        this.$dispatch('setPager', {
          prop: 'offset',
          value: newOffset,
        })
        if (this.localStore) this.localStore.setItemValue('pager', this.pager)
        EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'scroll' })
      }
    },
  },
  mounted() {
    if (this.infiniteScroll) {
      this.$nextTick(() => {
        window.onscroll = this.checkVisible
      })
    }
    this.isLoading = false
  },
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .card-container:nth-child(odd) {
    padding-inline-end: 0.5rem;
  }
}
.card-container {
  padding-block-end: 0.5rem;
}
</style>
